import { useDashboardBranding } from '@modules/Shared/Components/Branded/useDashboardBranding';
import React from 'react';

interface BrandedContentProps {
	zealContent?: React.ReactNode | null;
	brandedContent?: React.ReactNode | null;
}

/**
 * This component is used to handle displaying either Branded content or Zeal content.
 * It handles the logic for displaying the correct content based on dashboard type.
 */
export default function BrandedContent({
	zealContent = null,
	brandedContent = null,
}: BrandedContentProps) {
	const { isBranded } = useDashboardBranding();

	return isBranded ? brandedContent : zealContent;
}
